export default __webpack_public_path__ + "static/media/type2.7ea707d0.svg";